import React, { useState } from "react";
import { NumberFields } from "../Fields";
import {
  Alert,
  Box,
  Button,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Switch,
  TextField,
  useTheme,
} from "@mui/material";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { createYupSchema } from "../../../utilities/yupSchemaCreator";
import { useWhatsAppNumber } from "../provider";
import { useParams } from "react-router-dom";
import ErrorsList from "../../../ui/ErrorsList";

const yupSchema = NumberFields.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);

const FormNumber = ({ number, handleSuccess }) => {
  const { id } = useParams();
  let theme = useTheme();
  const [error, setError] = useState(null);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: number,
  });
  const { AddNumber, editNumber } = useWhatsAppNumber();
  const onSubmit = async (values) => {
    try {
      if (number) {
        await editNumber(number?.id, values);
      } else await AddNumber(id, values);
      handleSuccess();
    } catch (error) {
      console.log(error, "error");
      setError({
        title: error?.errors.message
          ? error.errors.message
          : "sone thing wrong",
      });
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      {error ? (
        <Alert severity="error" sx={{ my: 3 }}>
          <ErrorsList error={error} />
        </Alert>
      ) : (
        ""
      )}
      {NumberFields.map((f, index) => (
        <Box key={index}>
          {f.switch ? (
            <FormGroup>
              <FormLabel
                component="legend"
                sx={{
                  mt: theme.dimensions.mt,
                }}
              >
                {f.label}
              </FormLabel>
              <FormControlLabel
                sx={{
                  mt: theme.dimensions.mt,
                }}
                control={
                  <Switch
                    color="success"
                    defaultChecked={number ? number?.isActive : true}
                  />
                }
                {...register(f?.name)}
                label="Active"
              />
            </FormGroup>
          ) : (
            <TextField
              label={f.label}
              name={f.name}
              error={!!errors[f.name]}
              helperText={errors[f.name]?.message}
              select={f.select}
              className={f.class}
              fullWidth
              required
              disabled={f.disabled}
              sx={{
                width: theme.dimensions.width,
                mt: theme.dimensions.mt,
                mb: theme.dimensions.mb,
              }}
              inputProps={{
                ...register(f?.name),
                required: f.required,
              }}
              size="small"
            />
          )}
        </Box>
      ))}
      <Button
        type="submit"
        sx={{
          background: theme.color.blackBackground,
          color: "white",
          width: "100%",
          mb: 1.3,
          "&:hover": { background: `${theme.color.black}` },
        }}
      >
        save{" "}
      </Button>
      <Button
        onClick={handleSuccess}
        sx={{
          background: theme.color.gray200,
          color: "black",
          width: "100%",
          "&:hover": {
            background: `${theme.color.gray300}`,
          },
        }}
      >
        Cancel
      </Button>
    </form>
  );
};

export default FormNumber;
